// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"2e75ec3495b1abd8","src_app_modules_customers_customers_module_ts":"0c89673aec84d4f5","src_app_modules_admin_admin_module_ts":"53cf453add86b8b1","src_app_modules_system-logs_system-logs_module_ts":"4b4ed52a5e47a226","node_modules_xlsx_xlsx_mjs":"08eaff598e155337"}[chunkId] + ".js";
};